// extracted by mini-css-extract-plugin
export default {"idCheckMessage":"add-security-rule-modal__id-check-message__OVt_o"};